import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { LaboratoryDashboardPage } from './laboratory/laboratory-dashboard.page';

export const dashboardRoutes: Routes = [
    { path: 'laboratory', component: LaboratoryDashboardPage, canActivate: [AuthGuard] },
];

@NgModule({
    imports: [],
    exports: [RouterModule]
})
export class DashboardsRoutingModule {
    public static components = [
        LaboratoryDashboardPage,
    ];
}